// Resources
import { getAllClinics } from "API/Resource/clinic";

// Redux
import { openSnackbar } from "Store/SnackbarSlice";

export const fetchClinics = async ({
  setLoading,
  setActiveClinics,
  setInactiveClinics,
  dispatch,
  canceledRef,
}) => {
  setLoading(true);

  try {
    const response = await getAllClinics(false);
    if (!canceledRef?.current) {
      setActiveClinics(response.filter((clinic) => clinic.isActive === true));
      setInactiveClinics(response.filter((clinic) => clinic.isActive === false));
    }
  } catch (error) {
    if (!canceledRef?.current) {
      dispatch(openSnackbar({ message: error.message, severity: "error" }));
    }
  } finally {
    setTimeout(() => {
      if (!canceledRef?.current) {
        setLoading(false);
      }
    }, 2000);
  }
};
